/**
 * sora-wishlist-pdp.js
 * - Injects your custom wishlist button into [data-sora-wl]
 * - Mirrors Swym state (count + added) from #swym-embed-pdp-btn-wrapper
 * - Click on custom button triggers Swym button click
 */

(() => {
  const SELECTORS = {
    slot: '[data-sora-wl]',
    swymWrapper: '#swym-embed-pdp-btn-wrapper',
    swymText: '#swym-atw-pdp-button-text, .swym-atw-button-text',
  };

  const HEART_OUTLINE = `
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.7" stroke="currentColor" aria-hidden="true">
      <path stroke-linecap="round" stroke-linejoin="round"
        d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z" />
    </svg>
  `;

  const HEART_SOLID = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="m11.645 20.91-.007-.003-.022-.012a15.247 15.247 0 0 1-.383-.218 25.18 25.18 0 0 1-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0 1 12 5.052 5.5 5.5 0 0 1 16.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 0 1-4.244 3.17 15.247 15.247 0 0 1-.383.219l-.022.012-.007.004-.003.001a.752.752 0 0 1-.704 0l-.003-.001Z"/>
    </svg>
  `;

  const parseCount = (text) => {
    if (!text) return 0;
    const m =
      String(text).match(/\((\d+)\)\s*$/) ||
      String(text).match(/(\d+)\s*$/);
    return m ? Number(m[1]) : 0;
  };

  const getSwymBtn = (wrapper) =>
    wrapper?.querySelector("button") || wrapper?.querySelector(".swym-atw-button");

  const isAdded = (swymBtnEl) => {
    if (!swymBtnEl) return false;
    const cls = swymBtnEl.className || "";
    if (cls.includes("added") || cls.includes("atw-button-added")) return true;
    const ap = swymBtnEl.getAttribute("aria-pressed");
    return ap === "true";
  };

  const buildUI = () => {
    const slot = document.querySelector(SELECTORS.slot);
    if (!slot) return null;

    // Prevent duplicates (if section re-renders)
    if (slot.querySelector(".sora-wl-btn")) return slot.querySelector(".sora-wl-btn");

    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "sora-wl-btn";
    btn.setAttribute("aria-label", "Add to wishlist");

    btn.innerHTML = `
      <span class="sora-wl-count" data-sora-wl-count>0</span>
      <span class="sora-wl-icon" aria-hidden="true">
        <span class="sora-heart-outline">${HEART_OUTLINE}</span>
        <span class="sora-heart-solid">${HEART_SOLID}</span>
      </span>
    `;

    slot.innerHTML = "";
    slot.appendChild(btn);
    return btn;
  };

  const syncFromSwym = (customBtn) => {
    const wrapper = document.querySelector(SELECTORS.swymWrapper);
    if (!wrapper) return;

    const swymBtn = getSwymBtn(wrapper);
    if (!swymBtn) return;

    const swymTextEl =
      document.getElementById("swym-atw-pdp-button-text") ||
      wrapper.querySelector(SELECTORS.swymText);

    const count = parseCount(swymTextEl ? swymTextEl.textContent : "");
    const added = isAdded(swymBtn);

    const countEl = customBtn.querySelector("[data-sora-wl-count]");
    if (countEl) countEl.textContent = String(count);

    customBtn.classList.toggle("is-added", added);
    customBtn.setAttribute("aria-pressed", added ? "true" : "false");
    customBtn.setAttribute("aria-label", added ? "Added to wishlist" : "Add to wishlist");
  };

  const clickSwym = () => {
    const wrapper = document.querySelector(SELECTORS.swymWrapper);
    if (!wrapper) return;
    const swymBtn = getSwymBtn(wrapper);
    if (swymBtn) swymBtn.click();
  };

  const init = () => {
    const customBtn = buildUI();
    if (!customBtn) return;

    const start = Date.now();

    const tick = () => {
      const wrapper = document.querySelector(SELECTORS.swymWrapper);
      const swymBtn = wrapper ? getSwymBtn(wrapper) : null;

      if (wrapper && swymBtn) {
        syncFromSwym(customBtn);

        // Observe Swym wrapper for updates
        const obs = new MutationObserver(() => syncFromSwym(customBtn));
        obs.observe(wrapper, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
        });

        // Click -> proxy to Swym
        customBtn.addEventListener("click", (e) => {
          e.preventDefault();
          clickSwym();
          // Sync shortly after Swym updates
          setTimeout(() => syncFromSwym(customBtn), 200);
          setTimeout(() => syncFromSwym(customBtn), 800);
        });

        return;
      }

      // Try up to 8s while Swym loads
      if (Date.now() - start < 8000) requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
